// Rewarded-video ad popup.
// Used by the Navbar "+" icon (earn coins any time) and by the Category page
// (shown when the user doesn't have enough coins to enter a contest).
//
// "Watch Ads" shows a real Google H5 rewarded ad (adBreak). Coins are credited
// to the wallet inside showRewardedAd() once the full ad is watched, which
// fires the "coinsUpdated" event so the Navbar balance refreshes automatically.

import { useState } from "react";
import { AD_REWARD } from "../utils/coins";
import { showRewardedAd } from "../utils/ads";

function AdRewardModal({ show, onClose, message, onRewarded, rewardAmount = AD_REWARD }) {
  const [watching, setWatching] = useState(false);

  if (!show) return null;

  const handleWatch = () => {
    setWatching(true);
    showRewardedAd({
      onSuccess: (balance) => {
        setWatching(false);
        if (onRewarded) onRewarded(balance);
        onClose();
      },
      onDismissed: () => {
        // skipped early → no reward
        setWatching(false);
        onClose();
      },
    });
  };

  const handleCancel = () => {
    if (watching) return;
    onClose();
  };

  return (
    <div className="ad-modal-overlay" onClick={handleCancel}>
      <div className="ad-modal" onClick={(e) => e.stopPropagation()}>
        {watching ? (
          <div className="ad-watching">
            <div className="ad-spinner" />
            <p className="mb-0 mt-3">Loading ad… please wait</p>
          </div>
        ) : (
          <>
            <p className="ad-modal-text">
              {message ||
                `Click on video ad to get ${rewardAmount} reward coins.`}
            </p>
            <div className="ad-modal-actions">
              <button className="ad-cancel-btn" onClick={handleCancel}>
                Cancel
              </button>
              <button className="ad-watch-btn" onClick={handleWatch}>
                Watch Ads
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AdRewardModal;
